import React, { useState } from 'react'
import { useGetBirthdayNotifications } from '../../redux/company/hook'
import SendWish from './send-wish'
import EmptyTableSVG from '../../assets/svg/empty-table.svg'
import LoadingBar from '../loader-bar'

const BirthdayNotifications = () => {
  const [wish, sendWish] = useState(false)
  const [employeeData, setEmployeeData] = useState()
  const { data: birthdayNotifications, isLoading } =
    useGetBirthdayNotifications()

  if (isLoading) {
    return <LoadingBar loading={isLoading} />
  }
  return (
    <>
      <main className='flex flex-col w-full'>
        {birthdayNotifications?.length > 0 ? (
          <div className='grid gap-3 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full'>
            {birthdayNotifications?.map((birthday) => (
              <div
                key={birthday?.id}
                className='flex flex-col gap-2.5 bg-white rounded-md p-3 shadow-md'
              >
                <p className='text-sm font-medium'>
                  Hurray It’s {birthday?.first_name} {birthday?.last_name}{' '}
                  birthday 🎉
                </p>
                <div className='w-full flex justify-between items-center gap-2.5'>
                  <p className='text-xs font-medium'>
                    Date: {birthday?.created}
                  </p>
                  {birthday?.is_birthday && birthday?.is_me !== 1 && (
                    <button
                      onClick={() => {
                        sendWish(true)
                        setEmployeeData(birthday)
                      }}
                      className='bg-[#238B45] cursor-pointer rounded-md h-[32px] w-[91px] flex items-center justify-center text-white font-semibold text-sm'
                    >
                      Send wish
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className='flex items-center justify-center w-full mt-10'>
            <img
              src={EmptyTableSVG}
              alt='No Data Fetched'
              width={'50%'}
            />
          </div>
        )}
      </main>

      {wish && (
        <SendWish
          isOpen={wish}
          employeeData={employeeData}
          closeModal={() => {
            sendWish(false)
            setEmployeeData(null)
          }}
        />
      )}
    </>
  )
}

export default BirthdayNotifications
